const gtagManager = ({ eventName, eventData }) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: eventName,
        ...eventData,
    })
}

export default gtagManager
